// Stand-in for the load-funds BFF mutation until live data is wired in.
export const loadFunds = (_amountCents: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, 1500);
  });
